<template>
  <v-form ref="vennDataEditorForm">
    <v-row dense>
      <v-col v-for="(item,index) in lazyValue" :key="index" :cols="cols">
        <v-textarea :rules="[rules.required,rules.analyseContent]" class="caption x-dense" hide-details rows="5" placeholder="请参考右侧示例数据" v-model="item.value" outlined :label="item.name" @change="onChange(index)" @keydown.native="onItemTextKeydown($event,index)"></v-textarea>
        <v-row dense justify="end" align="center">
          <v-col cols="auto" v-if="item.editNameFlag">
            <mini-text-editor width="100" v-model="item.editName" v-if="item.editNameFlag"></mini-text-editor>
            <a class="caption primary--text ml-2" @click="onEditNameCancel(index)">取消</a>
            <a class="caption primary--text ml-2" @click="onEditNameOk(index)">确定</a>
          </v-col>
          <v-col cols="auto" v-else>
            <a class="caption primary--text" @click="onEditName(index)">修改名称</a>
            <a class="caption primary--text ml-2" v-if="lazyValue.length>min" @click="onDelete(index)">删除</a>
            <a class="caption primary--text ml-2" v-if="!!lazyValue[lazyValue.length-1].value && index==lazyValue.length-1 && (!max || lazyValue.length<max)" @click="onAdd">添加</a>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
/**
 * 返回的数据格式为：
 * list1  list2   list3
 * xx1    xx2     xx3
 */
import { required, analyseContent } from '@/plugins/rules';

export default {
  props: {
    min: { type: [Number, String], default: 1 },
    max: { type: [Number, String], default: 5 },
    cols: { type: [Number, String], default: 3 },
    value: { type: String }
  },
  data () {
    return {
      lazyValue: [], // [{name:'xx',data:['xx','xx']}]
      maxNo: 0,
      rules: { required: required(), analyseContent: analyseContent() }
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      this.lazyValue = this.convertToData();
      this.maxNo = this.lazyValue.length;
      if (!this.lazyValue.length) this.onAdd();
    },
    validate () {
      let ret = this.$refs.vennDataEditorForm.validate();
      return ret;
    },
    onChange (index) {
      if (index || index === 0) {
        let values = this.lazyValue[index].value.split('\n');
        let filtedValues = values.filter(v => !!v);
        this.lazyValue[index].data = filtedValues;
        this.lazyValue[index].value = filtedValues.join('\n');
      }
      let value = this.convertToValue();
      this.$emit('input', value);
    },
    onItemTextKeydown (e, index) {
      if (e.keyCode == 9) {
        this.lazyValue[index].value += '\t';
        e.returnValue = false;
      }
    },

    onEditName (index) {
      this.lazyValue[index].editNameFlag = true;
    },
    onEditNameCancel (index) {
      this.lazyValue[index].editNameFlag = false;
    },
    onEditNameOk (index) {
      this.lazyValue[index].name = this.lazyValue[index].editName;
      this.lazyValue[index].editNameFlag = false;
    },
    onDelete (index) {
      this.lazyValue.splice(index, 1);
      this.onChange();
    },
    onAdd () {
      let name = `list${++this.maxNo}`;
      this.lazyValue.push({ name: name, editName: name, editNameFlag: false, data: [], value: '' });
      this.onChange();
    },
    convertToData () {
      if (!this.value) return [];
      let rows = this.value.split('\n');
      let cols = rows[0].split('\t');
      let ret = [];
      for (let i = 0; i < cols.length; i++) ret.push({ name: cols[i], editName: cols[i], editNameFlag: false, data: [] })
      for (let i = 1; i < rows.length; i++) {
        let row = rows[i];
        let values = row.split('\t');
        for (let m = 0; m < cols.length; m++) {
          ret[m].data.push(values[m]);
        }
      }
      ret.forEach(group => {
        let groupData = group.data;
        let filtedData = groupData.filter(v => !!v);
        group.data = filtedData;
        let value = filtedData.join('\n');
        group.value = value;
      });
      return ret;
    },
    convertToValue () {
      if (!this.lazyValue.length) return '';
      let ret = [];
      let names = [], values = [];
      for (let i = 0; i < this.lazyValue.length; i++) {
        let group = this.lazyValue[i];
        names.push(group.name);
        let groupData = group.data || [];
        for (let m = 0, n = groupData.length; m < n; m++) {
          if (!values[m]) values[m] = [];
          if (groupData[m]) values[m][i] = groupData[m];
        }
      }
      ret.push(names.join('\t'));
      values.forEach(v => ret.push(v.join('\t')));
      return ret.join('\n');
    }
  }
}
</script>
<style lang="scss">
.x-dense {
  textarea {
    line-height: 14px !important;
  }
}
</style>
